import { Component, ElementRef, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, ViewChild, HostListener, SimpleChanges, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-bars-graph',
    templateUrl: './bars-graph.component.html',
    styleUrls: ['./bars-graph.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BarsGraphComponent implements OnInit {
	@ViewChild('barsgraph', { static: true }) divToMeasureElement: ElementRef;

	@Input() showNumber: number;
	@Input() xlabel: string;
	@Input() ylabel: string;
	@Input() dataType: string;
	@Input() dataTypeY: string;
	@Input() type: string;
	@Input() max: number;
	@Input() heigth: number = 400;
	@Input() list: any;
	@Input() xlabelValue: string
	@Input() yObjects: any;
	@Input() overlap: boolean = true;
	@Input() oneBarOnly: boolean = false;
	@Input() showAverage: boolean = false;
	@Input() averageValue: string = 'average';
	@Input() rotateLabelsX: boolean = false;

	readonly SPACE_ROTATED_LABEL: number = 35;
	viewBoxwidth: number = 1024;
	viewBoxheigth: number = 500;
	separatorIndex: number = 50;
	viewBoxSize: string = "0 0 1024 500";
	position: number = 0;
	range: any = [];
	cursorPoistion: number = 30
	tooltipPoistion: number = 0
	tooltipValue: any;
	average: any;
	graphRefHeight: number;

	zoom(ev) {
		if (ev == 'in') {
			if (this.showNumber > 5) {
				this.showNumber += 5
			} else {
				this.showNumber += 1
			}
			if (this.showNumber > this.list.length) {
				this.showNumber = this.list.length
			}

		} else {
			// showNumber > 5
			if (this.showNumber > 5) {
				this.showNumber -= 5
			} else {
				this.showNumber -= 1
			}
			if (this.showNumber < 1) {
				this.showNumber = 1
			}
		}
		this.position = 0
	}
	next() {
		if (this.showNumber > 5) {
			this.position += 5
		} else {
			this.position += 1
		}

	}
	previous() {
		if (this.showNumber > 5) {
			this.position -= 5
		} else {
			this.position -= 1
		}

		if (this.position < 0) {
			this.position = 0
		}
	}

	getSpaceX() {
		return (this.viewBoxwidth - 35 - 24) / (this.showNumber + 1)
	}
	labelPosition(pos) {
		var a = 35 + (this.getSpaceX() * (pos + 1));
		return a
	}
	getBarWidth() {
		var a = this.getSpaceX();
		if (this.oneBarOnly) {
			return a * 0.5
		} else {
			return a / (this.yObjects.length + 1) * .8
		}

	}
	getBarX(pos, gPos) {
		var a = this.getSpaceX();
		if (this.oneBarOnly) {
			return this.labelPosition(pos) - this.getBarWidth() / 2;
		} else {
			return (this.labelPosition(pos) + (this.getBarWidth() * (gPos)) + (a / (this.yObjects.length + 1) * .2 * (gPos + 1))) - (a / 2) - (a / (this.yObjects.length + 1) * .1) + (a / (this.yObjects.length + 1) * 0.5)
		}
	}

	getBarheight(item, graph) {
		var a = (this.graphRefHeight - 30) * item[graph.value] / this.max;
		return a
	}

	getAverageHeight(graph) {
		let bottom = this.graphRefHeight - 20;
		let avg = graph[this.averageValue];
		if (avg == null || !this.max) return bottom;
		var a = bottom - (((this.graphRefHeight - 30) * avg) / this.max);
		return a;
	}

	getXLabel(item, isContext = false) {
		if (this.xlabelValue) {
			let text = item[this.xlabelValue];
			return this.rotateLabelsX && !isContext ? `${text.slice(0, 10)}${text.length > 10 ? '...' : ''}` : text;
		} else {
			return "--"
		}

	}
	setCursor(ev, pos, value) {
		if (ev.offsetY < 30) {
			this.cursorPoistion = ev.offsetY + 20
		} else {
			this.cursorPoistion = ev.offsetY - 30
		}
		this.tooltipPoistion = pos;
		this.tooltipValue = value;
	}
	getAverage() {
		var a = {}
	}
	getMinutes(ev) {
		var min = Math.floor(ev / 60)
		var sec = ev - (min * 60)

		if (sec < 10) {
			return min + ':0' + sec
		} else {
			return min + ':' + sec
		}
	}

	calculateYGraphs() {
		for (const item of this.list) {
			let accY = this.graphRefHeight - 20;
			for (const graph of this.yObjects) {
				// Normal Y calculation
				if (this.overlap || graph.type == 'total') {
					item['posY_' + graph.type] = (this.graphRefHeight - 20) - this.getBarheight(item, graph);
					accY = item['posY_' + graph.type];
					continue;
				}
				// No overlap calculations
				accY -= this.getBarheight(item, graph);
				item['posY_' + graph.type] = accY;
			}
		}
	}

	setViewBoxSizes() {
		setTimeout(() => {
			this.viewBoxwidth = this.divToMeasureElement.nativeElement.offsetWidth;
			this.viewBoxheigth = this.heigth;
			if (this.viewBoxheigth < 200) {
				this.viewBoxheigth = 200
			}
			this.viewBoxSize = "0 0 " + this.viewBoxwidth + " " + this.viewBoxheigth;
			this.graphRefHeight = this.rotateLabelsX ? this.viewBoxheigth - this.SPACE_ROTATED_LABEL : this.viewBoxheigth;
			this.separatorIndex = (this.graphRefHeight - 30) / 10;
			this.calculateYGraphs();
			this._cD.detectChanges();
		}, 0);
	}

	getXLabelRotation(i) {
		if (!this.rotateLabelsX) return;
		return `rotate(45, ${(this.labelPosition(i))}, ${this.graphRefHeight - 15})`
	}

	constructor(
		private _cD: ChangeDetectorRef,
	) { }

	ngOnInit() {
		this.range = new Array(10);
		this.setViewBoxSizes();
		this.getAverage();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.list) {
			this.setViewBoxSizes();
		}
	}

}
